export default __webpack_public_path__ + "static/media/samuel-scalzo-large.5e6b801c.jpg";